module.exports = __webpack_public_path__ + "img/bankitphone.53d9a1be.png";